import * as ForgotPassword_en from './ForgotPassword.en.js';
import * as ForgotPassword_es from './ForgotPassword.es.js';

const ForgotPasswordTuple = [
  { type: 'ForgotPassword', language: 'en', object: ForgotPassword_en.default },
  { type: 'ForgotPassword', language: 'es', object: ForgotPassword_es.default },
];

export default ForgotPasswordTuple;
